import * as actionTypes from './actionsTypes';

export const setCurrentPageParticipation = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_PARTICIPATION,
  payload: page
});

export const setValueParticipation = (value) => ({
  type: actionTypes.SET_VALUE_PARTICIPATION,
  payload: value
});


export const setSortFieldParticipation = (field) => ({
  type: actionTypes.SET_SORT_FIELD_PARTICIPATION,
  payload: field
});

export const setOrderParticipation = (order) => ({
  type: actionTypes.SET_ORDER_PARTICIPATION,
  payload: order
});

